const HIGHEST = 1;
const AVERAGE = 2;
const LAST    = 3;

const KEEP_CONFIGURATION = 1;
const ALLOW_ATTEMPTS    = 2;
const NOT_ALLOW_ATTEMPTS = 3;


const getRetryTypeIdByAvaliaType = (id) => {
  return {
    'last'   : LAST,
    'bigger' : HIGHEST,
    'media'  : AVERAGE
  } [id];
};

const getValidAttemptText = (retryTypeId) => {
  if (retryTypeId === HIGHEST) {
    return 'student.quiz.retries.validRetryTypeBiggestGrade';
  } else if (retryTypeId === AVERAGE) {
    return 'student.quiz.retries.validRetryTypeAverageGrade';
  } else if (retryTypeId === LAST) {
    return 'student.quiz.retries.validRetryTypeLastAttempt';
  }
};

export default {
  HIGHEST,
  AVERAGE,
  LAST,
  KEEP_CONFIGURATION,
  ALLOW_ATTEMPTS,
  NOT_ALLOW_ATTEMPTS,
  getRetryTypeIdByAvaliaType,
  getValidAttemptText
};
